import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetMarkerSyncStatusMutationVariables = Types.Exact<{
  input: Types.SetMarkerSyncStatusInput;
}>;


export type SetMarkerSyncStatusMutation = { __typename?: 'Mutation', setMarkerSyncStatus: { __typename?: 'MarkerSyncStatus', assetId: string, sequenceId?: string | null, status: Types.MarkerSyncStatusState } };


export const SetMarkerSyncStatus = /*#__PURE__*/ gql`
    mutation SetMarkerSyncStatus($input: SetMarkerSyncStatusInput!) {
  setMarkerSyncStatus(input: $input) {
    assetId
    sequenceId
    status
  }
}
    ` as unknown as DocumentNode<SetMarkerSyncStatusMutation, SetMarkerSyncStatusMutationVariables>;

          

          export const useSetMarkerSyncStatusMutation = (options?:MutationHookOptions<SetMarkerSyncStatusMutation, SetMarkerSyncStatusMutationVariables>) => useMutation(SetMarkerSyncStatus, options);
          

          export type SetMarkerSyncStatusMutationOptions = MutationHookOptions<SetMarkerSyncStatusMutation, SetMarkerSyncStatusMutationVariables>;

          

          export type SetMarkerSyncStatusMutationResult = ReturnType<typeof useSetMarkerSyncStatusMutation>[1];

          
